import { render, staticRenderFns } from "./LiveChatMp4Message.vue?vue&type=template&id=32e7034a&scoped=true&"
import script from "./LiveChatMp4Message.vue?vue&type=script&lang=js&"
export * from "./LiveChatMp4Message.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatMp4Message.vue?vue&type=style&index=0&id=32e7034a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e7034a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VTextField})
